import { render, staticRenderFns } from "./GlobalComplaintsSideMenu.vue?vue&type=template&id=12e21c11&"
import script from "./GlobalComplaintsSideMenu.vue?vue&type=script&lang=js&"
export * from "./GlobalComplaintsSideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports